#import "../fragments/tag-basic.graphql"

query GetTagsBasic($first: Int, $after: String, $input: TagsQueryInputType!) {
    tags(first: $first, after: $after, input: $input) {
        totalCount
        pageInfo {
            hasNextPage
            endCursor
        }
        edges {
            node {
                ...TagBasic
            }
        }
    }
}
